import request from '@/router/axios';

let urlPrefix = '/api/io/labexpreservationconfig';


/**
 * 获取所有教师预约范围
 */
export const getAllExpReserva = () => {
    return request(`${urlPrefix}/all`);
};

